import React from 'react';
import { DefaultFlexStrechedWrapper } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { ReportOptionDescriptionText, ReportOptionIconWrapper, ReportOptionWrapper } from '../PageHeaderStowage.style';
import { OptionOpacityWrapper } from './reportPanel.style';

interface IncludeAllTanksSelectorProps {
    includeAllTanks: boolean;
    setIncludeAllTanks: (includeAllTanks: boolean) => void;
    disabled?: boolean;
}

const IncludeAllTanksSelector: React.FC<IncludeAllTanksSelectorProps> = ({ includeAllTanks, setIncludeAllTanks, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIncludeAllTanks(event.target.checked);
    };

    return (
        <ReportOptionWrapper onClick={() => !disabled && setIncludeAllTanks(!includeAllTanks)} disabled={disabled}>
            <OptionOpacityWrapper disabled={disabled}>
                <DefaultFlexStrechedWrapper noMargin>
                    <ReportOptionIconWrapper>
                        <input
                            type="checkbox"
                            checked={includeAllTanks}
                            onChange={handleChange}
                            onClick={(e) => e.stopPropagation()}
                            aria-label="Include all tanks"
                            disabled={disabled}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        />
                    </ReportOptionIconWrapper>
                    <ReportOptionDescriptionText>Include all tanks</ReportOptionDescriptionText>
                </DefaultFlexStrechedWrapper>
            </OptionOpacityWrapper>
        </ReportOptionWrapper>
    );
};

export default IncludeAllTanksSelector;
